var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCardIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.836 2.333H2.169c-.92.001-1.666.758-1.667 1.693v7.615c.001.934.747 1.691 1.667 1.692h11.667c.92 0 1.666-.758 1.666-1.692V4.026c0-.935-.746-1.692-1.666-1.693Z",
  stroke: "#979797"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 7.5a2.5 2.5 0 1 0-5 0c0 .762.35 1.437.89 1.896C7.769 9.98 7 11.505 7 12.854a.5.5 0 1 0 1 0c-.008-.899.467-2.086 1.244-2.538a2.5 2.5 0 0 1 2.512 0c.777.452 1.252 1.639 1.244 2.538a.5.5 0 1 0 1 0c0-1.35-.769-2.874-1.89-3.458.54-.46.89-1.134.89-1.896Zm-4 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM2.286 6.062c-.158 0-.286.196-.286.438s.128.438.286.438h3.428c.158 0 .286-.196.286-.438s-.128-.438-.286-.438H2.286Zm.014 3c-.166 0-.3.196-.3.438s.134.438.3.438h2.4c.166 0 .3-.196.3-.438s-.134-.438-.3-.438H2.3Z",
  fill: "#979797"
}))));

export default SvgCardIcon;